export default (theme) => ({
  detailControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 80px 20px 60px',
    borderBottom: `1px solid ${theme.palette.disabled.main}`,
    boxSizing: 'border-box',
    [theme.breakpoints.down('xl')]: {
      padding: '20px 40px 20px 20px',
    },
  },
  backButton: {
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    '& svg': {
      width: 45,
      height: 45,
      transition: 'fill .2s linear',
      '&:hover': {
        fill: theme.palette.primary.main,
      },
    },
  },
});
